import { ChecklistsQuestion } from "../interfaces/checklists-question.interface";

export function isQuestionAnswered(question: ChecklistsQuestion): boolean {
    let isAnswered = false;
    if(question.UserAnswer && (question.UserAnswer.Answer || (question.UserAnswer.ResultClassValueID && question.UserAnswer.ResultClassValueID != 0))){
      isAnswered = question.UserAnswer != null;
    } else if(question.UserAnswer != undefined){
      const hasValue = question.UserAnswer.Value != undefined && question.UserAnswer.Value.length > 0;
      const hasRemarks = question.UserAnswer.Remarks != undefined && question.UserAnswer.Remarks.length > 0;
      const hasAttachments = question.UserAnswer.Attachments != undefined && question.UserAnswer.Attachments.length > 0;
      isAnswered = hasValue || hasRemarks || hasAttachments;
    }
    return isAnswered;
  }

  //TODO: Temp: property checked should come from the backend?
  export function isQuestionChecked(question: ChecklistsQuestion): boolean {
    let isChecked = false;
    if(question.UserAnswer && (question.UserAnswer.Answer || (question.UserAnswer.ResultClassValueID && question.UserAnswer.ResultClassValueID != 0))){
      isChecked = question.UserAnswer != null;
    } else if(question.UserAnswer != undefined){
      isChecked = question.UserAnswer.Value != undefined && question.UserAnswer.Value.length > 0;
    }
    return isChecked;
  }